import { ListFilterBase } from "generated/openApi";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const useInitListFilter = <T extends ListFilterBase>(initListFilter?: T) => {
  const pageSize = useSelector((state: RootState) => state.userSetting.pageSize);

  let _initListFilter = { ...initListFilter } as T;
  if (_initListFilter.page === undefined) _initListFilter.page = 1;
  if (_initListFilter.pageSize === undefined) _initListFilter.pageSize = pageSize;
  const [listFilter, setListFilter] = useState<T>(_initListFilter);

  return { listFilter, setListFilter };
};
